import { ApiDiscipline } from '@/services/disciplines.service';

export const transformGetDisciplinesResponse = (data: string) => {
  const { data: parsedData } = JSON.parse(data);

  return (
    parsedData?.map(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (item: any): ApiDiscipline => ({
        name: item?.data?.label,
        slug: item?.data?.name,
      })
    ) ?? []
  );
};
